export function dash_bord_component(state = 'PUBLICAÇÕES', action) {
  if (action.type === 'CHANGE_COMPONENTE') {
    return action.value;
  }

  return state;
}
